import { AttributesView, toAttributes } from "@bagel-web/components";
import styled from "styled-components";

import { CommonAgentSummary, AgentConfig } from "../types";
import { formatTimestamp, getFriendlyAgentName } from "../util";
import AgentIcon from "./AgentIcon";

const AgentName = styled.span`
  margin-bottom: 4px;
  font-weight: bold;
`;

const MetadataLabel = styled.div`
  margin: 4px 0px;
  font-weight: bold;
`;

export type NamedConfig = {
  name: string;
  config: Record<string, unknown>;
};

const AgentDetails = ({
  agent,
  showName = true,
}: {
  agent: CommonAgentSummary | null;
  showName?: boolean;
}) => {
  const agentName = getFriendlyAgentName(agent);
  const agentConfig: AgentConfig | undefined = agent?.config;

  return (
    <>
      {showName && (
        <div>
          {agentName ? (
            <>
              <AgentIcon className="me-2" agent={agent} />
              <AgentName>{agentName}</AgentName>
              <div>
                <AgentName>
                  <code>{agent?.id}</code>
                </AgentName>
              </div>
            </>
          ) : (
            <>
              <AgentIcon className="me-2" agent={agent} />
              <AgentName>
                <code>{agent?.id}</code>
              </AgentName>
            </>
          )}
        </div>
      )}
      <>
        {agentConfig?.name && (
          <AttributesView
            showEmpty={false}
            attributes={[
              {
                name: "created",
                label: "created",
                value: formatTimestamp(agentConfig?.created),
              },
              {
                name: "destroyed",
                label: "destroyed",
                value: formatTimestamp(agentConfig?.destroyed),
              },
              {
                name: "llm_name",
                label: agentConfig?.config?.agent_llm ? "Agent LLM" : "LLM",
                value: agentConfig?.config?.agent_llm
                  ? agentConfig?.config?.agent_llm
                  : agentConfig?.config?.llm_config?.name,
              },
              {
                name: "temperature",
                label: "Temperature",
                value: agentConfig?.config?.llm_config?.config?.temperature,
              },
            ]}
          />
        )}
        {Object.entries(agentConfig?.config?.component_configs || {}).length >
          0 && (
          <>
            <MetadataLabel>Components</MetadataLabel>
            <AttributesView
              showEmpty={false}
              attributes={toAttributes(
                Object.entries(agentConfig.config.component_configs).reduce(
                  (acc, [k, v]) => {
                    const nc = v as NamedConfig;
                    acc[k] =
                      `${nc.name}${nc.config.use_service ? ` (${nc.config.use_service})` : ""}`;
                    return acc;
                  },
                  {} as Record<string, string>
                )
              )}
            />
          </>
        )}
        {Object.entries(agentConfig?.config?.service_configs || {}).length >
          0 && (
          <>
            <MetadataLabel>Services</MetadataLabel>
            <AttributesView
              showEmpty={false}
              attributes={toAttributes(
                Object.entries(agentConfig.config.service_configs).reduce(
                  (acc, [k, v]) => {
                    const nc = v as NamedConfig;
                    acc[k] = `${nc.name}`;
                    return acc;
                  },
                  {} as Record<string, string>
                )
              )}
            />
          </>
        )}
        {Object.entries(agent?.metadata || {}).length > 0 && (
          <>
            <MetadataLabel>Metadata</MetadataLabel>
            <AttributesView
              showEmpty={false}
              attributes={toAttributes(agent?.metadata)}
            />
          </>
        )}
      </>
    </>
  );
};

export default AgentDetails;
